import { isYes } from '../../../../../../../components/loan_application/utils/helpers';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const { systemPropertyHasRelatedTenants } = loanFormModel.formField;

class SystemPropertyHasRelatedTenants implements Rule {
  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const systemPropertyHasRelatedTenantsValue =
      application[systemPropertyHasRelatedTenants.name];

    return isYes(systemPropertyHasRelatedTenantsValue);
  }
}

export default new SystemPropertyHasRelatedTenants();
